module.exports = __webpack_public_path__ + "img/email.d238b902.svg";